import { type FunctionComponent } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy.js';
import { Author } from '../author/Author.tsx';

import { type Answers_question$data } from './__generated__/Answers_question.graphql.ts';
import styles from './answers.scss';

type Props = {
    question: Answers_question$data;
};

const AnswersComponent: FunctionComponent<Props> = ({ question }) => {
    const answers = question?.answers;
    if (answers && answers.length > 0) {
        return (
            <div className={styles.wrapper}>
                {answers.map(answer => {
                    if (answer) {
                        const { text, serviceId, formattedCreatedDate, author } = answer;
                        if (text && serviceId) {
                            return (
                                <div
                                    key={serviceId}
                                    className={styles.answer}
                                    id={`suggestedAnswer${serviceId}`}
                                >
                                    <div
                                        className={styles.answerText}
                                        dangerouslySetInnerHTML={{ __html: text }}
                                        data-tn="answer-text"
                                    />
                                    <Author
                                        author={author}
                                        formattedCreatedDate={formattedCreatedDate}
                                    />
                                </div>
                            );
                        }
                    }
                    return null;
                })}
            </div>
        );
    }

    return null;
};

export const Answers = createFragmentContainer(AnswersComponent, {
    question: graphql`
        fragment Answers_question on QuestionType {
            answers {
                serviceId
                text
                formattedCreatedDate
                author {
                    ...Author_author
                }
            }
        }
    `,
});
